<template>
  <UiLayer v-if="!onRootPage"></UiLayer>
  <main class="Page">
    <ComponentRender :components="components" :pageData="getPageData"></ComponentRender>
  </main>
</template>


<script>
import ComponentRender from "./ComponentRender.vue";
import UiLayer from "./UiLayer.vue";

export default {
  name: 'Page',
  components: {
    ComponentRender,
    UiLayer
  },
  data() {
    return {
      components: [],
      onRootPage: false
    }
  },
  mounted() {
    this.getPageComponents();
    this.onRootPage = app.manifest.onRootPage();
  },
  async beforeRouteUpdate(to, from) {
    var pageExists = app.manifest.pageExists(to.path);
    if (!pageExists) {
      console.log(`You tried to navigate to ${to.path}.\npageExists: ${pageExists}\nCheck manifest to see if this specifc page exists.`)
      return false;
    }

    this.$store.commit("setPreviousRoute", from.path);

    setTimeout(() => {
      this.components = this.getPage.components;
      this.onRootPage = app.manifest.onRootPage();
    }, 0);
  },
  methods: {
    getPageComponents() {
      this.getPage.components.forEach(component => {
        this.components.push(component);
      });
    }
  },
  computed: {
    getPage() {
      return app.manifest.getPage(this.$route.path) || {};
    },
    getPageData() {
      return this.getPage.data;
    }
  },
}
</script>

<style lang="scss">
.Page {
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>